import React, { useEffect, useState } from 'react';
import { FiCheckCircle, FiBookOpen, FiInbox } from 'react-icons/fi';
import { allocationService } from '../services/supabaseClient';

const formatPrice = (price, currency) => {
  if (!price) return 'Free';
  const symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : '₹';
  return `${symbol}${price}`;
};

export default function MyContent({ session }) {
  // allocation rows for this partner only, already joined with the full
  // course row (name, type, price, currency, delivered_by...) — see
  // allocationService.getForPartner in supabaseClient.js
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const data = await allocationService.getForPartner(session.partnerId);
        if (!cancelled) setRows(data || []);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Could not load your content.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [session.partnerId]);

  return (
    <div className="panel">
      <div className="panel-head">
        <div>
          <h2>Allocated Courses & Certifications</h2>
        </div>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="content-grid">
        {loading && (
          <div className="empty">Loading your content…</div>
        )}

        {!loading && rows.map(row => {
          const c = row.course;
          const isCert = (c?.type || '').toLowerCase().includes('cert');
          const seatsLeft = (row.seats ?? 0) - (row.seats_used ?? 0);

          return (
            <article className="content-card" key={row.allocation_id}>
              <div className="content-icon">
                {isCert ? <FiCheckCircle /> : <FiBookOpen />}
              </div>
              <span className="tag">{c?.type || '—'}</span>
              <h3>{c?.name || 'Untitled content'}</h3>
              <p>{c?.delivered_by || 'Wiiz learning programme'}</p>

              {c?.course_code && (
                <p className="content-meta-code">{c.course_code}</p>
              )}

              <div className="content-foot">
                <b>{formatPrice(c?.price, c?.currency)}</b>
                <span className="status active">Allocated</span>
              </div>

              <div className="content-seats">
                {row.seats
                  ? `${seatsLeft} of ${row.seats} seats left`
                  : 'Unlimited seats'}
              </div>
            </article>
          );
        })}

        {!loading && !rows.length && (
          <div className="empty">
            <FiInbox />
            <span>No Course/Certification has been allocated yet.</span>
          </div>
        )}
      </div>
    </div>
  );
}